import { getColor, rgbaColor } from '@/helpers/utils';

/** Plot height shared by the three competitor cards so charts and legends line up. */
export const DASHBOARD_PLOT_HEIGHT = 248;

/** Own brand + up to 5 competitors; order validated for CVD separation in light and dark. */
export const OWN_BRAND_COLOR = '#e63757';
export const COMPETITOR_COLORS = ['#2563eb', '#059669', '#7c3aed', '#d97706', '#db2777'];

/** User-selected Falcon theme color (`--falcon-primary`). */
export function themePrimary(): string {
  return getColor('primary') || '#2c7be5';
}

/** Strong → light steps of the theme color for ordinal ramps. */
export function themePrimaryRamp(isDark: boolean): [string, string, string] {
  const primary = themePrimary();
  if (isDark) {
    return [rgbaColor(primary, 0.95), rgbaColor(primary, 0.7), rgbaColor(primary, 0.4)];
  }
  return [primary, rgbaColor(primary, 0.7), rgbaColor(primary, 0.4)];
}

export function competitorColors(): string[] {
  return [themePrimary(), '#059669', '#7c3aed', '#d97706', '#db2777'];
}

export function brandSeriesColor(isOwn: boolean, competitorIndex: number): string {
  const colors = competitorColors();
  return isOwn ? OWN_BRAND_COLOR : colors[competitorIndex % colors.length];
}

/** Theme-aware chart chrome; read inside a memo keyed on `isDark`. */
export function chartChrome() {
  return {
    axisLabel: getColor('gray-700'),
    axisLine: getColor('gray-300'),
    splitLine: getColor('gray-200'),
    muted: getColor('gray-600'),
    strongText: getColor('gray-1100'),
    /** Card background, used for the gaps between adjacent marks. */
    surface: getColor('emphasis-bg'),
    tooltipBg: getColor('gray-100'),
    tooltipBorder: getColor('gray-300'),
    tooltipText: getColor('gray-1100'),
  };
}

export const escapeHtml = (value: string) =>
  value.replace(
    /[&<>"']/g,
    (char) =>
      ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' })[char]!,
  );
